import { DocumentFormDto, type DocumentFormInterface } from '@zaoblako/shared/modules/document/dtos/document/document-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DocumentTypeCodeValidateTools } from '@zaoblako/shared/modules/document/classes/document.type.code.validate.tools';
import type { DocumentTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-find.dto';

import * as yup from 'yup';

/** Document create API request body */
export interface DocumentCreateInterface extends DocumentFormInterface {
  /** Document type */
  documentType: DocumentTypeFindInterface;
  /** If `true` then spawned document will be created */
  isCreateLinkedDocument?: boolean;
}

/** Document create API request body - DTO schema */
export const DocumentCreateDto = SerdeDtoClass.from<DocumentFormInterface, DocumentCreateInterface>(
  DocumentFormDto,
  DocumentDtoKeysEnum.DOCUMENT_CREATE_DTO,
  {
    documentType: {
      label: 'Тип документа',
      serializer: (): yup.Schema<any> => {
        const tools = DocumentTypeCodeValidateTools.getInstance();
        return yup.object({
          code: yup
            .string()
            .matches(tools.matchRegex, tools.errorMessage)
        });
      }
    },
    isCreateLinkedDocument: {
      optional: true,
      label: 'Создать связанный документ',
      serializer: yup.boolean(),
    },
  },
);
